export default __webpack_public_path__ + "static/media/picasso-example.15954519.png";